// extracted by mini-css-extract-plugin
export default {"section":"NotFound_section__R-wlz","container":"NotFound_container__dvLOl","text":"NotFound_text__0q9lj","handle":"NotFound_handle__ZkUxr","blink":"NotFound_blink__AZCXG"};